import moment from 'moment';
import { capitalize, debounce, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import Modal from '../../../../components/uiComponent/modal/index';
import { Drawer, List, ListItem, ListItemText, Divider, Box } from '@mui/material';
import { Checkbox, DatePicker, notification, Spin, Tooltip } from 'antd';
import { PiCalendarBlankLight } from "react-icons/pi";
import WarningIcon from '../../../../assets/icons/warning-modal-icon.svg';
import MarkAsResolved from '../../../../assets/icons/mark-as-resolved-icon.svg';
import Receiving from "../../../../assets/icons/Receiving.svg"




import FileUpload from '../../../../components/uiComponent/upload/uploadNew';
import PoCardItemDetails from '../../../../components/uiComponent/PoCardItemDetails'
import Button from "../../../../components/uiComponent/button/index";
import Select from "../../../../components/uiComponent/select/index";
import Input from "../../../../components/uiComponent/inputs/input";
import Badge from '../../../../components/uiComponent/bages';

import {
  BulkReceive,
  CreateReceiveHistory,
  getWarehousePoDetails,
  ScanProduct,
  SetPoState,
  UpdatePo
} from '../../../../slices/po';
import { GetPresignedUrl } from '../../../../slices/aws-services';

import ProductImage from '../../../../assets/icons/product-image.svg';
import BarcodeIcon from '../../../../assets/icons/bar-code-icon.svg';
import NoBarcode from '../../../../assets/icons/no-bar-code.svg';
import ArrowLeft from '../../../../assets/icons/arrow-left-blue.svg';
import BarcodeBorderIcon from '../../../../assets/icons/bar-code+border.svg';
import leftArrowIcon from '../../../../assets/icons/left-arrow.svg';

import { ModalWrapper, PoDetailsMobileWrapper } from './style'
import ReactSelect from '../../../../components/uiComponent/select/index';
import { PoWarehouseDetailsWrapper } from '../../../purchase-order/po-warehouse-details/style';

const PoDetailsMobile = () => {
  const { id } = useParams();
  const modalPromiseRef = useRef(null); 
  const [bulkReceivingModal, setBulkReceivingModal] = useState(false);

  const [isScanProduct, setIsScanProduct] = useState();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { scannedProduct } = useSelector(state => state.pos);
  const [scanProductId, setScanProductId] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(scannedProduct);
  const [receivingLoading, setReceivingLoading] = useState(false);
  const [receivingModalOpen, setReceivingModalOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filters, setFilters] = useState({ itemsFilter: '' });

  const navigate = useNavigate();
  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });

  const {
    poWarehouseDetails = [],
    totalWarehousePoDetailsCount,
    po_name,
    po_status,
    fetchingWarehousePoDetails,
    updatePoLoading,
    scanProductLoading,
    createReceivingLoading,
    bulkReceivingLoading
  } = useSelector(state => state.pos);

  const handleGetPoDetails = () => {
    dispatch(getWarehousePoDetails({
      page,
      id,
      filters: { ...filters, itemsFilter: filters?.itemsFilter },
    }));
  };

  const handleItemsFilter = (e) => {
    const receivedFilter = e?.target?.checked ? 'viewAll' : 'unreceived';
    setPage(page => ({ ...page, pageNumber: 1 }));
    setFilters(filters => ({ ...filters, itemsFilter: receivedFilter }));
  };

  const handleBulkReceive = () => {
    dispatch(BulkReceive({ poId: id })).then(({ payload }) => {
      if (payload.success) {
        handleGetPoDetails();
        setBulkReceivingModal(false);
      }
    })
  }


  useEffect(() => {
    id && handleGetPoDetails();
    dispatch(SetPoState({
      field: 'mobileReceivingHeading',
      value: 'Po Details'
    }));
  }, [id, page, filters]);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const poDetailsItems = Array.from({ length: 20 }, (_, index) => ({
    id: index + 1,
    productImage: ProductImage,
    productTitle: `African Net Sponge Blue 3 PCS - African ${index + 1}`,
    upc: `123453234${index + 1}`,
    invoiceQty: Math.floor(Math.random() * 1000) + 1,
  }));

  const users = [
    { value: 'user', label: 'user1' },
    { value: 'users', label: 'user2' },
  ];

  const ScanLoosePack = ({ setReceivingLoading }) => {
    const [activeTab, setActiveTab] = useState('loose');
    const [receivingBody, setReceivingBody] = useState({ 
      quantity: null,
      expiry_date: null,
      no_of_cases: null,
      in_a_case: null,
      unsellable_quantity: null,
      reason: null,
      isLoosepack: activeTab === 'loose' ? true : false
    });
    const [fileList, setFileList] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);


    const clearReceivingStates = () => {
      setReceivingBody({
        quantity: null,
        expiry_date: null,
        no_of_cases: null,
        in_a_case: null,
        unsellable_quantity: null,
        reason: null,
        isLoosepack: activeTab === 'loose' ? true : false,
      });
      setFileList([]);
      clearDrawerStates();
      setIsScanProduct(false);
    }

    const handleChange = (selected) => {
      setSelectedOption(selected);
    };

    const handleInputChange = (field, value) => {

      setReceivingBody((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    };

    const handleSubmit = async (fileUrls) => {
      const { quantity = 0, unsellable_quantity = 0, no_of_cases = 0, in_a_case = 0 } = receivingBody || {};
      let isReceived = false;
      if (Number(selectedProduct?.received_quantity) + Number(quantity) + Number(unsellable_quantity) +
        (Number(in_a_case) * Number(no_of_cases)) >= Number(selectedProduct?.invoice_quantity)) {
        isReceived = true;
      }
      dispatch(
        CreateReceiveHistory({
          ...receivingBody,
          urls: fileUrls,
          is_received: isReceived,
          po_item_id: selectedProduct?.id,
          isLoosepack: activeTab === 'loose' ? true : false,
          product_id: selectedProduct?.product?.id,
          poId: id
        })
      ).then(({ payload }) => {
        if(po_status != "Receiving"){
          dispatch(UpdatePo({ poId : id, status:"Receiving" })).then(()=>{
            handleGetPoDetails();
          })
        } 
        if (payload?.success) {
          notification.success({
          message: 'Receiving',
          description: 'Product Received Successfully'
          })
          handleGetPoDetails();
          clearDrawerStates();
        }
      });
    };

    const handleDisable = () => {
      if (isEmpty(receivingBody)) return true;
      const { quantity, unsellable_quantity, no_of_cases, in_a_case,  reason = '' } = receivingBody;
      if (activeTab === 'loose') {
        if (!quantity && !unsellable_quantity) return true;
        if ((quantity && quantity <= 0) || (unsellable_quantity && unsellable_quantity <= 0)) return true;
        if (unsellable_quantity && !reason) return true;
        if ((!unsellable_quantity || unsellable_quantity <= 0) && reason) return true;
        if (!unsellable_quantity && fileList?.length) return true;
        if (po_status?.toLowerCase() === 'confirmed' ) return true;
      } else {
        if ((!no_of_cases && in_a_case) || (no_of_cases && !in_a_case) || ((no_of_cases && no_of_cases <= 0) || (in_a_case && in_a_case <= 0))) return true;
        if (!no_of_cases && !in_a_case && !unsellable_quantity) return true;
        if (unsellable_quantity && !reason) return true;
        if (unsellable_quantity && unsellable_quantity <= 0) return true;
        if ((!unsellable_quantity || unsellable_quantity <= 0) && fileList?.length) return true;
        if ((!unsellable_quantity || unsellable_quantity <= 0) && reason) return true;
        if (po_status?.toLowerCase() === 'confirmed' ) return true;
      }
      return false;
    }
    const handleModalConfirm = () => {
      modalPromiseRef.current?.resolve(true); 
      setReceivingModalOpen(false); 
    };
  
    const handleModalCancel = () => {
      modalPromiseRef.current?.reject(); 
      setReceivingModalOpen(false); 
    };

    const btnDisable = handleDisable();
    const handleReceivePo = async () => {
      let userConfirmed = true;
      const { quantity = 0, unsellable_quantity = 0, no_of_cases = 0, in_a_case = 0 } = receivingBody || {};
      if ( Number(selectedProduct?.received_quantity) + Number(quantity) + Number(unsellable_quantity)+
         ( Number(in_a_case) * Number(no_of_cases) ) > Number(selectedProduct?.invoice_quantity))
       {
         userConfirmed = await new Promise((resolve) => {
          modalPromiseRef.current = {
            resolve: () => {
              setReceivingModalOpen(false);
              resolve(true); 
            },
            reject: () => {
              setReceivingModalOpen(false);
              resolve(false); 
            },
          };
          setReceivingModalOpen(true);
        });
      }
      
      if(!userConfirmed){
        return;
      } 

      if (
        (!receivingBody?.reason && receivingBody.unsellable_quantity) ||
        (!receivingBody.unsellable_quantity && receivingBody?.reason)
      ) {
        notification.error({
          message: 'Receiving Error',
          description: 'Unsellable Quantity and Reason are Required'
        });
        return;
      } else if (
        !receivingBody.unsellable_quantity &&
        !receivingBody.quantity &&
        (!receivingBody.no_of_cases || !receivingBody.in_a_case)
      ) {
        notification.error({
          message: 'Receiving Error',
          description: 'Quantity is Required'
        });
        return;
      } else if (fileList.length === 0 && !receivingBody.unsellable_quantity) {
        setReceivingLoading(true);
        await handleSubmit().then(() => {
          setReceivingLoading(false);
          clearReceivingStates();

        });
        return;
      }
      setReceivingLoading(true);
      const response = await dispatch(
        GetPresignedUrl({ files: fileList })
      );
      const attachments = response?.payload;
      const fileUrls = attachments?.map((attachment) => attachment?.url);
      await handleSubmit(fileUrls).then(() => {
        setReceivingLoading(false);
        clearReceivingStates();
      });
    };

    const options = [
      { value: "Damaged Products", label: "Damaged Products" },
      { value: "Expired Products", label: "Expired Products" },
      { value: "Other", label: "Other" },
    ];

    return (
      <PoDetailsMobileWrapper activeTab={activeTab}>
        <div className='scan-post-drawer-data'>
          <div className='header'>
            <img onClick={clearReceivingStates} src={ArrowLeft} alt={ArrowLeft} title={ArrowLeft} />
            <h2>Scan Product to Receive</h2>
          </div>
          <div className='drawer-inner-page-view'>
            {/* <Input className="bar-code-scanner" placeholder="Scan Barcode" label="Scan Product Barcode" endIcon={<img src={BarcodeBorderIcon} alt={BarcodeBorderIcon} title={BarcodeBorderIcon} />} /> */}
            <div className='card-item-wrapper'>
              <div className='cards-header'>
                <img src={selectedProduct?.product?.image_url || ProductImage} alt={selectedProduct?.product?.image_url || ProductImage} title={ProductImage} />
                <div className='card-content-wrapper'>
                  <p>{selectedProduct?.product?.name || 'N/A'} </p>
                  <div className='card-content-item-wrapper'>
                  <div className='card-content-item'>
                      <p>Brand:</p>
                      <p>{selectedProduct?.product?.brand || 'N/A'}</p>
                    </div>
                    <div className='card-content-item'>
                      <p>{selectedProduct?.product?.identifier_type?.toUpperCase()|| 'N/A'}:</p>
                      <p>{selectedProduct?.product?.identifier_value || '--'}</p>
                    </div>
                    <div className='card-content-item'>
                      <p>Invoice Qty:</p>
                      <p>{selectedProduct?.invoice_quantity || 0}</p>
                    </div>
                    <div className='card-content-item'>
                      <p>Received Qty:</p>
                      <p>{selectedProduct?.received_quantity || 0}</p>
                    </div>
                    <div className='card-content-item'>
                      <p>Brand:</p>
                      <p>{selectedProduct?.product?.brand || 'N/A'}</p>
                    </div>
                  </div>
                </div>
              </div> 
              <div className='tabs-wrapper'>
                <p className={`tab-button ${activeTab === 'loose' ? 'active' : ''}`}
                  onClick={() => setActiveTab('loose')}>
                  Loose Pack
                </p>
                <p
                  className={`tab-button ${activeTab === 'case' ? 'active' : ''}`}
                  onClick={() => setActiveTab('case')}>
                  Case Pack
                </p>
              </div>
              <div className='content-ui-tabs-wrapper'>
                <div className='inputs-container'>
                  <p>Sellable</p>
                  {activeTab === 'loose' ? <div className='inputs-items'>
                    <Input
                      overlayClassName="po-drawer-input"
                      type="number" placeholder="Enter"
                      label="Quantity"
                      value={receivingBody?.quantity || ''}
                      onChange={(e) =>
                        handleInputChange('quantity', Number(e.target.value))
                      }
                    />
                    <div className='inputs-item'>
                      <label>Expiry Date</label>
                      <DatePicker
                        dropdownClassName="date-picker-po-detail-drawer"
                        suffixIcon={<PiCalendarBlankLight />}
                        placeholder="Enter"
                        value={
                          receivingBody.expiry_date ? moment(receivingBody.expiry_date) : null
                        }
                        onChange={(date, dateString) =>
                          handleInputChange('expiry_date', dateString)
                        }
                      />
                    </div>
                  </div> : <div className='inputs-items'>
                    <Input
                      overlayClassName="po-drawer-input"
                      type="number"
                      placeholder="Enter"
                      label="No Of Cases"
                      value={receivingBody?.no_of_cases || ''}
                      onChange={(e) =>
                        handleInputChange('no_of_cases', Number(e.target.value))
                      }
                    />
                    <Input
                      overlayClassName="po-drawer-input"
                      type="text"
                      placeholder="Enter"
                      label="In a case"
                      value={receivingBody?.in_a_case || ''}
                      onChange={(e) =>
                        handleInputChange('in_a_case', Number(e.target.value))
                      }
                    />
                    <div className='inputs-item'>
                      <label>Expiry Date</label>
                      <DatePicker
                        dropdownClassName="date-picker-po-detail-drawer"
                        suffixIcon={<PiCalendarBlankLight />}
                        placeholder="Enter"
                        value={
                          receivingBody.expiry_date ? moment(receivingBody.expiry_date) : null
                        }
                        onChange={(date, dateString) =>
                          handleInputChange('expiry_date', dateString)
                        }
                      />
                    </div>
                  </div>}
                </div>
                <div className='inputs-container'>
                  <p>Unsellable</p>
                  <div className='inputs-items'>
                    <Input
                      overlayClassName="po-drawer-input"
                      type="number"
                      placeholder="Enter"
                      label="Quantity"
                      value={receivingBody?.unsellable_quantity || ''}
                      onChange={(e) =>
                        handleInputChange('unsellable_quantity', Number(e.target.value))
                      }
                    />
                    <div className='inputs-item'>
                      <ReactSelect
                        label="Reason"
                        options={options}
                        value={selectedOption}
                        onChange={ (e) => {
                          handleInputChange('reason', e?.value || '')
                          handleChange(e)
                        }}
                        placeholder="Choose a Reason"
                        isClearable={true}
                        className="mobile-receiving-select"
                      />
                    </div>
                  </div>
                </div>
                <FileUpload
                  onFileChange={(file) => console.log('File Changed', file)}
                  multiple={false}
                  label="Upload Image’s"
                  hintText="Drop your file here to upload"
                  buttonText="Browse"
                  showUploadedFiles={true}
                  drawerMobile
                  setFileData={() => { }}
                  fileList={fileList}
                  setFileList={setFileList}
                  setDataToProceed={() => { }}
                  setFileColumns={() => { }}
                  setFileRows={() => { }}
                />
              </div>
            </div>
          </div>
          <div className='footer-po-mobile'>
            <Button onClick={clearReceivingStates} className="outlined" text="Cancel" />
            <Button disabled={btnDisable} onClick={handleReceivePo} text="Save" />
          </div>
        </div>
        <Modal
          open={receivingModalOpen}
          onClose={handleModalCancel}
          onHide={handleModalCancel}
          closeText='Cancel'
          saveText='Confirm'
          header='Receive Confirmation'
          className='delete-confirmation-modal'
          closeButton={true}
          onSave={handleModalConfirm}
        >
          <ModalWrapper>
            <div className='delete-modal-wrapper' style={{ zIndex: 20 }}>
              <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
              <h3>Warning</h3>
              <p>The received quantity exceeds the invoice quantity.</p>
              <p>Do you still want to proceed?</p>
            </div>
          </ModalWrapper>
        </Modal>
      </PoDetailsMobileWrapper>
    )
  }

  const handleUpdatePo = () => {
    dispatch(UpdatePo({ poId: id, status: 'Processed' })).then(() => {
      handleGetPoDetails();
      navigate('/po-mobile');
    })
  };

  const handleScanId = debounce((e) => {
    setScanProductId(e.target.value);
  }, 500);

  const handleProductSelected = (item) => {
    setSelectedProduct(item);
    setOpen(true);
  };

  const clearDrawerStates = () => {
    setOpen(false);
    setSelectedProduct({});
    setScanProductId('');
  }

  useEffect(() => {
    scanProductId && dispatch(ScanProduct({ poId: id, identifierValue: scanProductId })).then(({ payload }) => {
      if (!payload.error) {
        setSelectedProduct(payload?.data);
        if (!isEmpty(payload?.data))
          setOpen(true);
      }
    });
  }, [scanProductId]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10 && poWarehouseDetails?.length < totalWarehousePoDetailsCount) {
      setPage((prev) => ({
        ...prev,
        pageSize: prev?.pageSize + 25
      }));
    }
  };


  return (
    <Spin tip='Scanning' spinning={scanProductLoading}>
      <PoDetailsMobileWrapper>
        {
          isScanProduct ?
            <div className='scan-overlay-wrapper'>
              <div
                className='flex  arrow-icon'
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'baseline',
                  gap: '8px'
                }}
                onClick={() => {
                  setIsScanProduct(false);
                  clearDrawerStates();
                }} ><img src={leftArrowIcon} alt='Left Arrow' />
                <p>Back</p>
              </div>
              <Input onChange={(e) => handleScanId(e)} className="bar-code-scanner" placeholder="Scan Barcode" label="Scan Product Barcode" endIcon={<img src={BarcodeBorderIcon} alt={BarcodeBorderIcon} title={BarcodeBorderIcon} />} />
              <div className='scan-code-wrapper'>
                <img src={NoBarcode} title={NoBarcode} alt={NoBarcode} />
              </div>
            </div>
            :
            <>
              <Spin tip='Receiving..' spinning={updatePoLoading}>
                <header>
                  <div className='title-wrapper'>
                    {po_name && po_name.length > 10 ? (
                      <Tooltip title={po_name} trigger={["click"]} placement="bottom">
                        <h2>{po_name.slice(0, 10) + '...'}</h2>
                      </Tooltip>
                    ) : (
                      <h2>{po_name || 'N/A'}</h2>
                    )}
                      <div className='header-item'>
                      <p>Status:</p>
                      <Badge simpleText status={capitalize(po_status) || 'N/A'} />
                      </div>
                    <div style={{display:'flex'}}>
                      {/* <p onClick={handleUpdatePo}>Mark as Received</p> */}
                      <Button text='Mark As Received' className={po_status?.toLowerCase() === 'processed' || po_status?.toLowerCase() === 'confirmed' || poWarehouseDetails.length === 0 ? 'disabled-save-button' : "map-btn-wrapper"} onClick={() => { setIsModalOpen(true) }} />
                      <Button className={po_status === 'Processed' || po_status?.toLowerCase() === 'confirmed' || poWarehouseDetails.length === 0 ? 'disabled-save-button' : 'map-btn-wrapper'} text='Bulk Receive' onClick={() => setBulkReceivingModal(true)} />
                    </div>
                  </div>
                </header>
              </Spin>
              <Checkbox
                className='mt-2'
                checked={filters?.itemsFilter === 'viewAll' ? true : false}
                defaultChecked={false}
                onChange={handleItemsFilter}>
                Include Received
              </Checkbox>
              <Spin tip='Loading..' spinning={fetchingWarehousePoDetails || createReceivingLoading}>
                <section onScroll={handleScroll}>
                  {poWarehouseDetails?.map((item) => (
                    <PoCardItemDetails
                      key={item.id}
                      onClick={po_status?.toLowerCase() != 'confirmed' ? () => handleProductSelected(item) : null}
                      cardClick={po_status?.toLowerCase() != 'confirmed' ? () => handleProductSelected(item) : null}
                      productImage={item?.product?.image_url || ProductImage}
                      productTitle={item?.product?.name || 'N/A'}
                      identifierType={item?.product?.identifier_type?.toUpperCase() || 'N/A'}
                      identifierValue={item?.product?.identifier_value || 'N/A'}
                      receivedQty={item?.received_quantity || 0}
                      brand={item?.product?.brand || 'N/A'}
                      invoiceQty={item?.invoice_quantity || 0}
                      status={po_status}
                    />

                  ))}
                  {
                    !poWarehouseDetails?.length && (<span className="mb-0 h-100 d-flex justify-content-center align-items-center w-100" style={{ color: 'grey', fontSize: '16px' }}>
                      No Record Found
                    </span>)}
                </section>
              </Spin>
              <div className='bottom-actions'>
                <Button
                  disabled={po_status?.toLowerCase() === 'confirmed'}
                  onClick={() => {
                    dispatch(SetPoState({
                      field: 'mobileReceivingHeading',
                      value: 'Receive Product'
                    }));
                    setIsScanProduct(true)
                  }} text="Scan Product" startIcon={<img src={BarcodeIcon} title={BarcodeIcon} alt={BarcodeIcon} />} />
              </div>
              <Modal
                open={isModalOpen}
                onClose={() => { setIsModalOpen(false) }}
                onHide={() => setIsModalOpen(false)}
                closeText='Cancel'
                saveText='Confirm'
                header='Received Confirmation'
                className='delete-confirmation-modal'
                closeButton={true}
                onSave={handleUpdatePo}
              >
                <ModalWrapper>
                  <div className='delete-modal-wrapper'>
                    <img src={MarkAsResolved} alt='WarningIcon' title='WarningIcon' />
                    <h3>Mark As Received</h3>
                    <p>Do You Mark This PO As Arrived ?</p>
                  </div>
                </ModalWrapper>
              </Modal>

              <Modal
        open={bulkReceivingModal}
        onClose={() => setBulkReceivingModal(false)}
        onHide={() => setBulkReceivingModal(false)}
        closeText="Cancel"
        saveText="Yes"
        className="delete-confirmation-modal"
        closeButton={true}
        onSave={() => {
          handleBulkReceive();
        }}
        buttonDisabled={bulkReceivingLoading}
      >
        <PoWarehouseDetailsWrapper>
          <div className='delete-modal-wrapper'>
            <img src={Receiving} alt='Receiving' title='Receiving' />
            <h3>Bulk Receive</h3>
            <p>Are You Sure You Want To Bulk Receive All Po Items?</p>
          </div>
        </PoWarehouseDetailsWrapper>
      </Modal>
      
            </>
        }
        <Drawer anchor="right" style={{ zIndex: 5 }} width={250} open={open} onClose={() => clearDrawerStates()}>
          <Spin tip='Receiving..' spinning={receivingLoading}>
            <ScanLoosePack setReceivingLoading={setReceivingLoading} />
          </Spin>
        </Drawer>
      </PoDetailsMobileWrapper>
    </Spin >
  )
}

export default PoDetailsMobile
